// id="file"のタグを取得
const fileInput = document.getElementById('FilePicker');

// FileReaderインスタンスを作成
const reader = new FileReader();

// 初期値を定義
let onlyProductVariants = [];
let addToCartCsvProducts = [];
let errorProducts = []; //エラーが出た商品
let uniqueErrorProducts;
let rowNumber = 1

// プロパティーの初期値
let cartItemPropertiesArr = [];

// ファイルが選択されたときにはしる関数
fileInput.onchange = () => {
  let result = fileInput.files[0];
  reader.readAsText(result);
  rowNumber = 1;
  errorProducts = [];
};

// カート内のプロパティーを取得
document.querySelectorAll('input.cartProperty').forEach(function(value) {
  // console.log(value.name)
  // console.log(value.value)
  cartItemPropertiesArr.push([value.name,value.value])
});;

// カート内のプロパティーをオブジェクトに変更
const cartItemPropertiesObj = Object.assign(...cartItemPropertiesArr.map(([key,value]) => ({[key]:value})))
// console.log(cartItemPropertiesObj) 

// ファイルが読み込まれたときにはしる関数
reader.onload = () => {

  // 見た目を初期化
  document.getElementById("sdtAddToCartButton").disabled = true;
  document.getElementById('outPutError').innerHTML = "";

  // 最初の\nのインデックス番号を取得
  let firstRowIndex = reader.result.indexOf('\n', 0);

  // 最初の改行の次の位置から文字列を抽出
  let outputString = reader.result.substr(firstRowIndex + 1);

  // console.log('outputString : ',outputString)

  // 得られた文字列を\nで切り分ける（行ごとの取得）
  var data = outputString.split('\n');
  // console.log(data)

  var jsonArray = [];

  // 1行目から「項目名」の配列を生成する
  var items = data[0].split(',');

  // 最初の行に「New Project」
  if(!items.includes('品番')){
    document.getElementById('outPutCsv').innerHTML = '';
    document.getElementById('outPutError').innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">選択されたCSVの形式は、システムデザインツールの形式と異なっております。<br>CSVをご確認の上、再度CSVを選択してください。</p>`;
    return
  }

  // CSVデータの配列の各行をループ処理する
  // 配列の先頭要素(行)は項目名のため処理対象外
  // 配列の最終要素(行)は空のため処理対象外
  for (var i = 1; i < data.length - 1; i++) {
    var line = new Object();

    // カンマで区切られた各データに分割する
    var csvArrayItems = data[i].split(',');

    // 各データをループ処理する
    for (var j = 0; j < items.length; j++) {
      // 要素名：items[j]
      // データ：csvArrayItems[j]
      line[items[j]] = csvArrayItems[j];
    }
    jsonArray.push(line);
  }

  var msg = JSON.stringify(jsonArray);

  // console.log(`msg: ${msg}`);

  var t = JSON.parse(msg);
  var keys = Object.keys(t[0]);

  // Noが重複している行を削除
  var noDuplicatesNo = t.filter((it) => {
    if( it["#"] && (it["#"] == rowNumber.toString() || it["#"].slice(1).slice(0, -1) == rowNumber.toString()) ) {
      rowNumber = rowNumber + 1
      return it
    }
  })

  // 正規表現で全ての”を削除
  let partNumbers = noDuplicatesNo.map( array => array.品番.replace(/"/g, ''))

  // 行数を初期化
  rowNumber = 1
  
  // console.log('partNumbers is',partNumbers)

  // innerHTMLで出力するコード
  let rs = `<table style="width:100%; table-layout:auto; text-align:center;">
              <thead>
                <tr>
                  ${keys.map( (key,index) => {
                    if(key == "#"){
                      return `<th style="width:auto; background-color:#6464E6; color:white; padding:10px 20px;">No</th>`
                    }
                    if(index <= 5){
                      return `<th style="width:auto; background-color:#6464E6; color:white; padding:10px 20px;">${key}</th>`
                    }
                  }).join('\n')}
                </tr>
              </thead>
              <tbody>
                ${noDuplicatesNo.map((it,index) => {
                  if(it["#"] == rowNumber.toString() || it["#"].slice(1).slice(0, -1) == rowNumber.toString() ) {
                    rowNumber = rowNumber + 1
                    return `<tr>${
                      keys.map((key,index) => {
                        if(index <= 5){
                          // 先頭と末尾がダブルコーテーションのとき削除
                          if(it[key].startsWith('"') && it[key].endsWith('"')){
                            if(it['品番'] == ""){
                              return `<td class="emptyPartNumber" style="padding:10px 20px;">${it[key].slice(1).slice(0, -1)}</td>`
                            }
                            return `<td class=${it['品番']} style="padding:10px 20px;">${it[key].slice(1).slice(0, -1)}</td>`
                          }

                          if(it['品番'] == ""){
                            return `<td class="emptyPartNumber" style="padding:10px 20px;">${it[key]}</td>`
                          }
                          // 先頭と末尾にダブルコーテーションがないときそのまま表示
                          return `<td class=${it['品番']} style="padding:10px 20px;">${it[key]}</td>`
                        }
                      }).join('\n')}</tr>`
                  }
                }).join('')}
              </tbody>
            </table>
          `;

  document.getElementById('outPutCsv').innerHTML = rs;
    
    // 商品の取得
    partNumbers.forEach((handle,index) => {

      if( handle == "" ){
        errorProducts.push("品番が未入力のもの");
        return
      }     
      // ハンドルによる商品の取得；入力した値と完全一致
      jQuery.getJSON(`/products/${handle}.js`, function(product) {

        // 商品のバリエーションリスト作成
        var productVariants = product.variants;

        // バリエーションIDごとの数量を取得する
        productVariants.map( m => {
          onlyProductVariants.push(m.id)
        })

        // productCountというオブジェクトにバリエーションIDと数量を入れる
        var productCount = {};
        for (var i = 0; i < onlyProductVariants.length; i++) {
        var elm = onlyProductVariants[i];
          productCount[elm] = (productCount[elm] || 0) + 1;
        }

        addToCartCsvProducts.splice(0, addToCartCsvProducts.length);

        for (const [key, value] of Object.entries(productCount)) {
          addToCartCsvProducts.push(
            {
              "id": Number(key),
              "quantity": Number(value),
              "properties" : cartItemPropertiesObj
            }
          )
        }

        if(productCount.length){
          productCount.map( m => {
            addToCartCsvProducts.push(m)
          })
        }
      })
      .error(function() {
        // ハンドルによる商品の取得；入力した値に「J」を追加して完全一致
        jQuery.getJSON(`/products/${handle}J.js`, function(product) {

          // console.log(`${handle}J`)

          // 商品のバリエーションリスト作成
          var productVariants = product.variants;

          // バリエーションIDごとの数量を取得する
          productVariants.map( m => {
            onlyProductVariants.push(m.id)
          })

          // productCountというオブジェクトにバリエーションIDと数量を入れる
          var productCount = {};
          for (var i = 0; i < onlyProductVariants.length; i++) {
          var elm = onlyProductVariants[i];
            productCount[elm] = (productCount[elm] || 0) + 1;
          }

          addToCartCsvProducts.splice(0, addToCartCsvProducts.length);

          for (const [key, value] of Object.entries(productCount)) {
            addToCartCsvProducts.push(
              {
                "id": Number(key),
                "quantity": Number(value),
                "properties" : cartItemPropertiesObj
              }
            )
          }

          // console.log(productCount)

          productCount.map( m => {
            addToCartCsvProducts.push(m)
          })
        })
        .error(function() {

          // console.log(`${handle}NJ`)

          // ハンドルによる商品の取得；入力した値に「NJ」を追加して完全一致
          jQuery.getJSON(`/products/${handle}NJ.js`, function(product) {

            // 商品のバリエーションリスト作成
            var productVariants = product.variants;

            // バリエーションIDごとの数量を取得する
            productVariants.map( m => {
              onlyProductVariants.push(m.id)
            })

            // productCountというオブジェクトにバリエーションIDと数量を入れる
            var productCount = {};
            for (var i = 0; i < onlyProductVariants.length; i++) {
            var elm = onlyProductVariants[i];
              productCount[elm] = (productCount[elm] || 0) + 1;
            }

            addToCartCsvProducts.splice(0, addToCartCsvProducts.length);

            for (const [key, value] of Object.entries(productCount)) {
              addToCartCsvProducts.push(
                {
                  "id": Number(key),
                  "quantity": Number(value),
                  "properties" : cartItemPropertiesObj
                }
              )
            }

            productCount.map( m => {
              addToCartCsvProducts.push(m)
            })
          })
          .error(function() {
            errorProducts.push(handle);
            uniqueErrorProducts = [...new Set(errorProducts)]
            document.getElementById('outPutError').innerHTML = `<p id='CSVErrorText' style="text-align: center; margin:0; color:red; padding:0 0 40px;">以下の商品は販売対象外となります。<br>対象外の商品(リスト内の赤背景商品)についてはカートに入りませんのでご注意ください。<br><span style="color:black; font-weight:bold;">${uniqueErrorProducts}</span></p>`;

            var list = document.getElementsByClassName(`${handle}`);
            for (var i = 0; i < list.length; i++) {
              var element = list[i];
              element.classList.add('notExistProduct');
            }
          });
        });
      });
      // 最後のときにカートボタンを有効化
      if( index == partNumbers.length - 1 ){
        document.getElementById("sdtAddToCartButton").disabled = false;
      }
    })
};



// カートページへ遷移する関数
function goToCartPage(){
  document.location.href = '/cart'
}

// カートに追加ボタン
function addToCart(){
  // カートに追加するデータ
  // var formData = {
  //   items: [
  //     {
  //       "id": 41002104062113,
  //       "quantity": 2,
  //       "properties" : {
  //         "配送方法": "通常配送"
  //       }
  //     },
  //     {
  //       "id": 41002105733281,
  //       "quantity": 2,
  //       "properties" : {
  //         "配送方法": "通常配送"
  //       }
  //     }
  //   ],
  // }

  var formData = {
    items: addToCartCsvProducts,
  }

  fetch("/cart/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .then(() => {
    goToCartPage()
  })
  .catch((error) => {
    console.error("Error:", error)
  })
}